
export const content = {

    copyright: 'Copyright 2025 – GDC Media Limited. All Rights Reserved.',
    disclaimer: 'DISCLAIMER: Online Wagering is illegal in some Jurisdictions. It is your responsibility to check your local regulations before playing online. GDC Media Ltd takes no responsibility for your actions.',
    mail: 'sales@betegy.com',
    rights: '© 2025. All rights reserved',
    policy: 'Privacy Policy'

}